import { useAuth } from 'context'
import { useEffect, useState } from 'react'
import { ErrorConstant, ReportSettingsService } from 'utility'

export const GetReportSettingsList = () => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const { user } = useAuth()
    const fetchData = async () => {
        try {
            setLoading(true)
            const list = await ReportSettingsService.getReportSettings({
                companyId: user.CompanyId,
                companySettingId: 0,
            })
            setData(list)
        } catch {
            setError(ErrorConstant.default)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    const refetch = () => {
        fetchData()
    }

    return { data, setData, error, loading, refetch }
}

export const GetReportSettingsMenuList = () => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const fetchData = async () => {
        try {
            setLoading(true)
            const list = await ReportSettingsService.getReportSettingsList()
            setData(list)
            console.log(list)
        } catch {
            setError(ErrorConstant.default)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    const refetch = () => {
        fetchData()
    }

    return { data, setData, error, loading, refetch }
}
